import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../Context/auth';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import ProducaoForm from '../Components/ProducaoForm/ProducaoForm';
import './Producao.css'; // Updated import

function NovaProducao() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [showImportarModal, setShowImportarModal] = useState(false);

    const handleSave = async (formData) => {
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/producao`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao criar Ordem de Produção');
            }

            const data = await response.json();
            Swal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'Ordem de Produção criada com sucesso!',
                confirmButtonColor: '#0d6efd'
            }).then(() => {
                navigate(`/app/editar-producao/${data.id}`);
            });

        } catch (error) {
            console.error("Erro ao criar OP:", error);
            setMensagem(error.message);
            Swal.fire('Erro', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="producao-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="producao-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/producao')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="producao-title m-0">
                            Nova <span className="highlight">Ordem de Produção</span>
                        </h1>
                    </div>
                    <button
                        className="btn btn-primary-custom"
                        onClick={() => setShowImportarModal(true)}
                        title="Importar itens de pedidos"
                    >
                        <i className="fas fa-file-import me-2"></i>Importar de Pedidos
                    </button>
                </div>

                <div className="producao-content">
                    <div className="form-card-container">
                        {mensagem && <div className="alert alert-danger mb-3">{mensagem}</div>}

                        <ProducaoForm
                            onSubmit={handleSave}
                            loadingSubmit={loading}
                            isEditing={false}
                            externalIsModalImportarVisible={showImportarModal}
                            externalSetIsModalImportarVisible={setShowImportarModal}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NovaProducao;
